import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, distinctUntilChanged, filter, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToolbarSearchService {

  readonly searchSubject = new BehaviorSubject<string>(null);
  get #search() {
    return this.searchSubject.value
  }

  #prevRoute: string;
  readonly #routeChangedObs = this._router.events.pipe(
    filter((ev) => ev instanceof NavigationEnd),
    map((ev: NavigationEnd) => ev.url),
    distinctUntilChanged()
  )

  readonly #routeSearchCache: Record<string, string> = {};
  readonly searchVisibleSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _router: Router
  ) {


    this.#routeChangedObs.subscribe((route) => {
      if (this.#prevRoute) {
        this.#routeSearchCache[this.#prevRoute] = this.#search
      }

      this.searchSubject.next(this.#routeSearchCache[route] || '');
      this.#prevRoute = route;
    })
  }



}
